// 5.24.0 FAQ — NDJSON reading for POST /api/faq/ask (same line protocol as /api/ask, Main.js sendToInsureIQ).
// lineSplitter is pure (unit-tested in faqStream.test.js); readNdjson drives it from a fetch Response.

export function lineSplitter(onEvent) {
  let buf = '';
  const flush = (line) => {
    const t = line.trim();
    if (!t) return;
    let ev;
    try { ev = JSON.parse(t); } catch (_e) { ev = { event: 'error', detail: 'Unreadable reply from the server', retryable: true }; }
    onEvent(ev);
  };
  return {
    push(text) {
      buf += text;
      let nl;
      while ((nl = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, nl);
        buf = buf.slice(nl + 1);
        flush(line);
      }
    },
    end() { const rest = buf; buf = ''; flush(rest); },
  };
}

export async function readNdjson(res, onEvent) {
  const split = lineSplitter(onEvent);
  if (!res.body || !res.body.getReader) { split.push(await res.text()); split.end(); return; }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    split.push(dec.decode(value, { stream: true }));
  }
  split.end();
}

// What the UI shows while waiting, from a status / retry event.
export function statusText(ev) {
  if (ev.event === 'retry') return 'The answer came back empty — asking again…';
  const w = ev.waited_s ? ` (${ev.waited_s}s)` : '';
  return `🧠 ${ev.message || 'Thinking — this can take a minute or two…'}${w}`;
}
